module.exports = __webpack_public_path__ + "img/xr2_detail_2.91d4f7ac.jpg";